/**
 * Default 30-minute time slots from 12:00 AM to 11:30 PM.
 * Shared by appointment-form, custom-date-picker, and reschedule-appointment-modal.
 */
export interface TimeSlotOption {
  time: string;
  displayTime: string;
  available: boolean;
}

function slot(h: number, m: number): TimeSlotOption {
  const t = `${String(h).padStart(2, '0')}:${m === 0 ? '00' : '30'}`;
  const hour12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
  const ampm = h < 12 ? 'AM' : 'PM';
  const displayTime = `${hour12}:${m === 0 ? '00' : '30'} ${ampm}`;
  return { time: t, displayTime, available: true };
}

const slots: TimeSlotOption[] = [];
for (let h = 0; h < 24; h += 1) {
  slots.push(slot(h, 0));
  slots.push(slot(h, 30));
}

export const DEFAULT_TIME_SLOTS: readonly TimeSlotOption[] = slots;

/** Build slots from startHour to endHour. If includeEndHalfHour, last slot is endHour:30; else endHour:00. */
function slotsBetween(startHour: number, endHour: number, includeEndHalfHour: boolean): TimeSlotOption[] {
  const result: TimeSlotOption[] = [];
  for (let h = startHour; h < endHour; h += 1) {
    result.push(slot(h, 0));
    result.push(slot(h, 30));
  }
  result.push(slot(endHour, 0));
  if (includeEndHalfHour) result.push(slot(endHour, 30));
  return result;
}

/** Default business-hours-style slots 09:00–17:30 (e.g. example-usage, demos). */
export const DEFAULT_TIME_SLOTS_9_17_30: readonly TimeSlotOption[] = slotsBetween(9, 17, true);

/** Default extended slots 08:00–18:00 (e.g. appointment-edit-form). */
export const DEFAULT_TIME_SLOTS_8_18: readonly TimeSlotOption[] = slotsBetween(8, 18, false);
